import { render, staticRenderFns } from "./base-text-field.vue?vue&type=template&id=73f8a2d3"
import script from "./base-text-field.ts?vue&type=script&lang=ts&external"
export * from "./base-text-field.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73f8a2d3')) {
      api.createRecord('73f8a2d3', component.options)
    } else {
      api.reload('73f8a2d3', component.options)
    }
    module.hot.accept("./base-text-field.vue?vue&type=template&id=73f8a2d3", function () {
      api.rerender('73f8a2d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vuetify/TextField/base-text-field.vue"
export default component.exports